import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';

declare const tl: any;

@Component({
  selector: 'app-public',
  templateUrl: './public.component.html',
  styleUrls: ['./public.component.css'],
  encapsulation: ViewEncapsulation.None // this allows parent styles to influence children
})

export class PublicComponent implements OnInit, OnDestroy {

  constructor() { }

  ngOnInit() {
    tl.pg.init({ steps_element: "#tlyPageGuidePUBLIC" });
  }

  ngOnDestroy() {
    tl.pg.closeOpenGuides();
    tl.pg.destroy('#tlyPageGuidePUBLIC');
  }
}



// WEBPACK FOOTER //
// ./src/app/app-public/public.component.ts